import enTranslations from './locales/en.json';
import teTranslations from './locales/te.json';

export const translations = {
  en: enTranslations,
  te: teTranslations,
};

export const supportedLanguages = [
  {
    code: 'en',
    label: 'English',
    nativeLabel: 'English',
    locale: 'en-IN',
    ogLocale: 'en_IN',
    rtl: false,
    needsCompactFont: false,
    browserPrefixes: ['en']
  },
  {
    code: 'te',
    label: 'Telugu',
    nativeLabel: 'తెలుగు',
    locale: 'te-IN',
    ogLocale: 'te_IN',
    rtl: false,
    needsCompactFont: true,
    browserPrefixes: ['te']
  }
];

export const getLanguageConfig = (code) => {
  return supportedLanguages.find(lang => lang.code === code) || supportedLanguages[0];
};
